import { lazy, Suspense, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Lenis from 'lenis';

import Curve from './components/Layout/Curve';
import Nav from './components/Layout/Nav';
import { UserMode } from './components/context/ModeContext';

import './style/App.scss';

const Home = lazy(() => import('./Pages/Home'));
const About = lazy(() => import('./Pages/About'));
const Galleries = lazy(() => import('./Pages/Galleries'));
const LoadingPage = lazy(() => import('./components/LoadingPage'));

const App = () => {
  const { darkMode, setDarkMode } = UserMode();
  // const [scope, animate] = useAnimate();
  // const { openGallery } = useGallery();

  const loc = useLocation();

  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then((registration) => {
          console.log('Service Worker enregistré avec succès !', registration);
        })
        .catch((error) => {
          console.error(
            'Erreur lors de l’enregistrement du Service Worker :',
            error
          );
        });
    });
  }

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 1000);

    const lenis = new Lenis();

    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
  }, [loc.pathname]);

  return (
    // <div className="dark:bg-black">
    <>
      <AnimatePresence mode="wait">
        <Nav />
      </AnimatePresence>

      <Curve backgroundColor={`${darkMode ? '#0e0d0e' : '#FFFFFF'}`}>
        <Suspense fallback={<LoadingPage />}>
          <Routes location={loc} key={loc.key}>
            <Route path="/" element={<Home />} />
            <Route path="/galleries" element={<Galleries />} />
            <Route path="/about" element={<About />} />
            {/* <Route path="/gallery/:galleryId" element={<Gallery />} /> */}
          </Routes>
        </Suspense>
      </Curve>
    </>
  );
};

export default App;
